import React from 'react';
import { FiCalendar, FiUser, FiArrowRight } from 'react-icons/fi';

const Blog = () => {
  const posts = [
    {
      title: 'The Future of Sustainable Water Base Solutions',
      excerpt:
        'Discover how biodegradable water base solution are revolutionizing industrial processes while protecting our environment.',
      author: 'Dr. Rajesh Kumar',
      date: 'December 1, 2025',
      category: 'Sustainability',
      image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&h=600&fit=crop',
    },
    {
      title: 'Maximizing Equipment Life: Best Practices',
      excerpt:
        'Learn expert tips for extending the lifespan of industrial equipment through proper maintenance and water base solution treatments.',
      author: 'Ms. Priya Sharma',
      date: 'November 28, 2025',
      category: 'Maintenance',
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&h=600&fit=crop',
    },
    {
      title: 'Parthenium Control: A Comprehensive Guide',
      excerpt:
        'Everything you need to know about effectively managing and eradicating Parthenium weed from agricultural land.',
      author: 'Mr. Amit Patel',
      date: 'November 25, 2025',
      category: 'Agriculture',
      image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&h=600&fit=crop',
    },
  ];

  const categories = [
    'All Posts',
    'Sustainability',
    'Maintenance',
    'Agriculture',
    'Industry Insights',
    'Product Updates',
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-vp-cream-100 via-white to-vp-cream-200">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDEzNGg4djdoLTh6Ci8+PC9nPjwvZz48L3N2Zz4=')] opacity-20"></div>
        
        <div className="relative container mx-auto px-4 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-vp-grey-900 mb-6">
            Our Blog
          </h1>
          <p className="text-lg md:text-xl text-black max-w-3xl mx-auto">
            Insights, updates, and industry knowledge from our experts
          </p>
        </div>
      </section>

      {/* Blog Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid lg:grid-cols-4 gap-12 max-w-7xl mx-auto">
            {/* Main Content */}
            <div className="lg:col-span-3 space-y-8">
              {posts.map((post, index) => (
                <article
                  key={index}
                  className="bg-white border-2 border-vp-grey-200 rounded-2xl overflow-hidden hover:border-vp-green-400 hover:shadow-xl transition-all duration-300"
                >
                  <div className="md:flex">
                    <div className="md:w-1/3 overflow-hidden">
                      <img 
                        src={post.image} 
                        alt={post.title}
                        className="w-full h-64 md:h-full object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="md:w-2/3 p-6 md:p-8">
                      <span className="inline-block px-3 py-1 bg-vp-green-600 text-white text-sm font-semibold rounded-full mb-3">
                        {post.category}
                      </span>
                      <h2 className="text-2xl md:text-3xl font-bold text-vp-grey-900 mb-3 hover:text-vp-green-600 transition-colors">
                        {post.title}
                      </h2>
                      <div className="flex items-center space-x-4 text-sm text-black mb-4">
                        <div className="flex items-center space-x-1">
                          <FiUser />
                          <span>{post.author}</span>
                        </div>
                        <div className="flex items-center space-x-1">
                          <FiCalendar />
                          <span>{post.date}</span>
                        </div>
                      </div>
                      <p className="text-black mb-4 leading-relaxed">
                        {post.excerpt}
                      </p>
                      <button className="inline-flex items-center space-x-2 text-vp-green-600 font-semibold hover:text-vp-green-700 transition-colors">
                        <span>Read More</span>
                        <FiArrowRight />
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1 space-y-8">
              {/* Categories */}
              <div className="bg-vp-grey-50 rounded-2xl p-6">
                <h3 className="text-xl font-bold text-vp-grey-900 mb-4">Categories</h3>
                <ul className="space-y-2">
                  {categories.map((category, index) => (
                    <li key={index}>
                      <button className="w-full text-left px-4 py-2 rounded-lg text-black hover:bg-vp-green-100 hover:text-vp-green-700 transition-colors">
                        {category}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-br from-vp-green-600 to-vp-blue-600 rounded-2xl p-6 text-white">
                <h3 className="text-xl font-bold mb-2">Stay Updated</h3>
                <p className="text-white text-sm mb-4">
                  Subscribe to our newsletter for the latest insights and product updates
                </p>
                <button className="w-full px-4 py-3 bg-white text-vp-green-600 font-semibold rounded-lg hover:shadow-lg transition-all">
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;



